import { useCallback } from 'react';
import { useImmerAtom } from 'jotai-immer';
import {
    splitInvoiceLineItemDispensesDataAtom,
    splitInvoiceLineItemDispensesTableViewAtom,
    splitInvoiceLineItemDispensesTableFiltersAtom,
    splitInvoiceLineItemDispensesTableStatsAtom,
} from './split_order_invoices_detail_atoms';
import { InvoiceLineItemDispensesDataItem } from './split_order_invoices_detail_types';
import { useTableData } from '../../../core/table/hooks/useTableData';
import { tableDataVM } from '../../../core/table/table_view_models';
import splitOrderInvoicesRepo from '../data/splitOrderInvoicesRepo';
import { ngDelegate } from '../../../core/services/ng.delegate';

type UseSplitInvoiceLineItemDispensesDataReturn = {
    items: InvoiceLineItemDispensesDataItem[];
    getListAsync: (invoiceId: string, lineId: string) => void;
};

export const useSplitInvoiceLineItemDispensesData = (): UseSplitInvoiceLineItemDispensesDataReturn => {
    const [view] = useImmerAtom(splitInvoiceLineItemDispensesTableViewAtom);
    const [filters] = useImmerAtom(splitInvoiceLineItemDispensesTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(splitInvoiceLineItemDispensesTableStatsAtom);
    const [data, setData] = useImmerAtom(splitInvoiceLineItemDispensesDataAtom);

    const { items } = useTableData<InvoiceLineItemDispensesDataItem>({ view, filters, stats, data, setStats });

    const getListAsync = useCallback(
        async (invoiceId: string, lineId: string): Promise<void> => {
            try {
                setData(() => tableDataVM<InvoiceLineItemDispensesDataItem>());
                const res = await splitOrderInvoicesRepo.getLineItemDispenses(invoiceId, lineId);
                setData(() => ({ items: res, dataItems: res }));
            } catch (err: any) {
                ngDelegate.warn(
                    'Failed to load backing dispenses',
                    'useSplitInvoiceLineItemDispensesData',
                    String(err?.status || ''),
                );
            }
        },
        [setData],
    );

    return { items, getListAsync };
};
